import Vue from 'vue';
import { DEVICE_TOKEN, SESSION_DATA_NAME } from '../config/constants';
import { ParticipantDeviceToken } from '../models/participantDeviceToken';

const service = {
    validationsCounter: 0,
    checkAuth() {
        Vue.$persistentStorage.get(SESSION_DATA_NAME).then(data => {
            if (!data) {
                this.logout();
            } else {
                Vue.$store.commit('user/setUserData', data);
                if (data.organization) {
                    Vue.$store.commit('organization/setSelectedOrganizationID', data.organization);
                }
            }
        });
    },
    authenticate(params) {
        return Vue.$explorer
            .makeRequest(
                '/api/authenticate',
                'POST',
                {
                    body: {
                        grant_type: 'admin',
                        ...params,
                    },
                },
                true
            )
            .then(response => {
                if (response.access_token) {
                    Vue.$persistentStorage.set(SESSION_DATA_NAME, response);
                    Vue.$store.commit('user/setUserData', response);
                    Vue.$store.commit('user/setMagicLoginToken', null);
                } else {
                    Vue.$store.commit('user/setUserData', null);
                }
            });
    },
    magicAuthenticate(params) {
        return Vue.$explorer
            .makeRequest(
                '/api/magic-login',
                'POST',
                {
                    body: {
                        grant_type: 'admin',
                        ...params,
                    },
                },
                true
            ).then(response => {
                if (response.success) {
                    if (response.validationToken) {
                        this.validationsCounter = 0;
                        const validationInterval = setInterval(() => {
                            this.magicTokenValidate(response.validationToken).then(r => {
                                ++this.validationsCounter;
                                if (r.tokenExist && r.token) {
                                    clearInterval(validationInterval);
                                    this.authenticate({ magic_login_token: r.token })
                                } else if (!r.tokenExist) {
                                    clearInterval(validationInterval);
                                } else if (this.validationsCounter == 20) {
                                    clearInterval(validationInterval);
                                }
                            });
                        }, 3000);
                    }
                }
                return response;
            });
    },
    magicTokenValidate(validateToken) {
        return Vue.$explorer
            .makeRequest(
                `/api/magic-login/${validateToken}`,
                'GET',
                {},
                true
            );
    },
    magicTokenConfirm(magicLoginToken) {
        return Vue.$explorer
            .makeRequest(
                `/api/magic-login/${magicLoginToken}`,
                'PATCH',
                {
                    body: {
                        confirmed: true,
                    },
                },
                true
            );
    },
    refreshToken() {
        return Vue.$persistentStorage.get(SESSION_DATA_NAME).then(data => {
            return Vue.$explorer
                .makeRequest(
                    '/api/authenticate',
                    'POST',
                    {
                        body: {
                            refresh_token: data.refresh_token,
                            grant_type: 'token_refresh',
                        },
                    },
                    true
                )
                .then(response => {
                    if (response.access_token) {
                        return Vue.$persistentStorage
                            .get(SESSION_DATA_NAME)
                            .then(data => {
                                Object.keys(response).forEach(key => {
                                    data[key] = response[key];
                                });
                                return data;
                            })
                            .then(data => {
                                return Vue.$persistentStorage.set(SESSION_DATA_NAME, data);
                            })
                            .then(() => {
                                Vue.$store.commit('user/setUserData', response);
                                return true;
                            });
                    } else {
                        this.logout();
                        return false;
                    }
                })
                .catch(() => {
                    this.logout();
                    return false;
                });
        });
    },
    logout() {
        Vue.$persistentStorage.get(DEVICE_TOKEN).then(r => {
            if (r) {
                ParticipantDeviceToken.delete(r);
            }
        });

        Vue.$persistentStorage.remove(SESSION_DATA_NAME).then(() => {
            Vue.$store.commit('user/setUserData', null);
            Vue.$store.commit('user/setAccessDenied', false);
            Vue.$store.commit('user/setGdprAccepted', false);
            Vue.$store.commit('organization/setSelectedOrganizationID', null);
        });
    },
};

export default {
    install(Vue, { router }) {
        Vue.$auth = service;
        Vue.prototype.$auth = service;
        let authChecked = false;
        router.beforeEach((...params) => {
            const [, , next] = params;
            if (!authChecked) {
                authChecked = true;
                Vue.$auth.checkAuth();
                next();
            } else {
                next();
            }
        });

        Vue.$router.onReady(() => {
            if (Vue.$router.currentRoute.query.hash) {
                Vue.$store.commit('user/setPasswordHash', Vue.$router.currentRoute.query.hash);

                Vue.$router.push({
                    path: Vue.$router.currentRoute.path,
                    ...Vue.$router.currentRoute.query,
                    hash: undefined,
                });
            }
        });
    },
};
